var React = require('react');

function CheckCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.06445 12C1.06445 18.0751 5.98932 23 12.0645 23C18.1396 23 23.0645 18.0751 23.0645 12C23.0645 10.9074 22.9052 9.85209 22.6086 8.8559L20.9435 10.5209C21.0231 11.0022 21.0645 11.4962 21.0645 12C21.0645 16.9706 17.035 21 12.0645 21C7.09389 21 3.06445 16.9706 3.06445 12C3.06445 7.02944 7.09389 3 12.0645 3C13.6769 3 15.1902 3.42402 16.4992 4.16663L17.956 2.70914C16.2528 1.62685 14.2319 1 12.0645 1C5.98932 1 1.06445 5.92487 1.06445 12ZM23.0645 4.4L21.6645 3L10.4645 14.2047L6.40381 10.2651L5.06445 11.6L10.4645 17L23.0645 4.4Z","fill":"#C7D5D9"}));
}

CheckCircleInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","role":"img","aria-label":""};

module.exports = CheckCircleInline;

CheckCircleInline.default = CheckCircleInline;
